/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Button, Card, Checkbox, Col, DatePicker, Divider, Empty, Layout, Popover, Row, Space, Table, Typography } from "antd";
import axios from "axios";
import { formatNumber } from "../../../../util/NumberFormatter";
import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer } from "recharts";
import MobileStatBox from "../../../common/MobileStatBox";
import useIsMobile from "../../../../util/useIsMobile";

dayjs.extend(customParseFormat);
dayjs.locale('ko');

const { RangePicker } = DatePicker;

const localDateTimeFormat = "YYYY-MM-DDTHH:mm:ss";

const initialState = {
  gameCount: 1,
  characterLevel: 0,
  gameRank: 9,
  playerKill: 0,
  playerAssistant: 0,
  monsterKill: 0,
  bestWeaponLevel: 0,
  mmrGain: 0,
  bonusCoin: 0,
  totalTime: 0,
  victory: 0,
  top3: 0,
  damageToPlayer: 0,
  damageFromPlayer: 0,
  damageToMonster: 0,
  damageFromMonster: 0,
  healAmount: 0,
  teamRecover: 0,
  addSurveillanceCamera: 0,
  addTelephotoCamera: 0,
  removeSurveillanceCamera: 0,
  removeTelephotoCamera: 0,
  useHyperLoop: 0,
  useSecurityConsole: 0,
  teamKill: 0,
  totalFieldKill: 0,
  rankPoint: 0,
  sumTotalVFCredits: 0,
  sumUsedVFCredits: 0,
  craftMythic: 0,
  playerDeaths: 0,
  ccTimeToPlayer: 0,
  battleZone1Winner: 0,
  totalGainVFCredit: 0,
  killPlayerGainVFCredit: 0,
  killChickenGainVFCredit: 0,
  killBoarGainVFCredit: 0,
  killWildDogGainVFCredit: 0,
  killWolfGainVFCredit: 0,
  killBearGainVFCredit: 0,
  killOmegaGainVFCredit: 0,
  killBatGainVFCredit: 0,
  killWicklineGainVFCredit: 0,
  killAlphaGainVFCredit: 0,
  killItemBountyGainVFCredit: 0,
  killDroneGainVFCredit: 0,
  totalUseVFCredit: 0,
  remoteDroneUseVFCreditMySelf: 0,
  remoteDroneUseVFCreditAlly: 0,
  transferConsoleFromMaterialUseVFCredit: 0,
  transferConsoleFromEscapeKeyUseVFCredit: 0,
  transferConsoleFromRevivalUseVFCredit: 0,
  tacticalSkillUpgradeUseVFCredit: 0,
  teamElimination: 0,
  teamDown: 0,
  teamBattleZoneDown: 0,
  teamRepeatDown: 0,
  campFireCraftUncommon: 0,
  campFireCraftRare: 0,
  campFireCraftEpic: 0,
  campFireCraftLegendary: 0,
  tacticalSkillUseCount: 0,
  creditRevivalCount: 0,
  creditRevivedOthersCount: 0,
  timeSpentInBriefingRoom: 0,
  crGetAnimal: 0,
  crGetMutant: 0,
  crGetPhaseStart: 0,
  crGetKill: 0,
  crGetAssist: 0,
  crGetTimeElapsed: 0,
  crGetCreditBonus: 0,
  crUseRemoteDrone: 0,
  crUseUpgradeTacticalSkill: 0,
  crUseTreeOfLife: 0,
  crUseMeteorite: 0,
  crUseMythril: 0,
  crUseForceCore: 0,
  crUseVFBloodSample: 0,
  crUseActivationModule: 0,
  crUseRootkit: 0,
  mmrGainInGame: 0,
  mmrLossEntryCost: 0,
  viewContribution: 0,
  useReconDrone: 0,
  useEmpDrone: 0
};

const excludeList = {
  'characterName': true,
  'bestWeapon': true,
  'tier': true
};

const TIER_KEYS = ['Normal', 'Iron', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond', 'Meteorite', 'Mithril+'];

function CharacterCell({ characterName, weaponName }) {
  const characterImgSrc = `/img/character/${characterName}.png`;
  const weaponImgSrc = `/img/weapon_skill/${weaponName}.png`;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textAlign: 'left'
      }}
    >
      <div style={{
        position: 'relative',
        width: '36px',
        height: '36px',
        marginRight: '8px',
        flexShrink: 0
      }}>
        <div style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: '#d6d6d6',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <img
            src={characterImgSrc}
            alt={characterName}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
        <img
          src={weaponImgSrc}
          alt={weaponName}
          style={{
            position: 'absolute',
            bottom: '0px',
            right: '-8px',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            backgroundColor: '#323232',
            padding: '2px',
            border: '1px solid #4A4A4A'
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
      <span style={{ whiteSpace: 'nowrap', color: '#1890ff' }}>
        {characterName} [{weaponName}]
      </span>
    </div>
  );
}

function sumTierStats(tierStats, tierFilter) {
  if (!Array.isArray(tierStats) || tierStats.length === 0) {
    return null;
  }
  const sum = {};
  let matched = false;
  tierStats.forEach(s => {
    if (tierFilter && !tierFilter(s.tier)) {
      return;
    }
    matched = true;
    Object.keys(s).forEach(key => {
      if (excludeList[key]) {
        return;
      }
      sum[key] = (sum[key] || 0) + (s[key] || 0);
    });
  });
  return matched ? sum : null;
}

function DualValue({ main, tier }) {
  return (
    <div>
      <div>{main}</div>
      {tier !== undefined && <div style={{ color: 'blue', fontSize: '0.85em' }}>{tier}</div>}
    </div>
  );
}

function EstherIndividualMobileCard({ stat, isSelected, onClick }) {
  const gameCount = stat.gameCount || 1;
  const tierGameCount = stat.tierData.gameCount || 1;
  const hasTierData = !!stat.tierData.gameCount;

  return (
    <Card
      size="small"
      style={{ marginBottom: 8, borderColor: isSelected ? '#1677ff' : undefined }}
      bodyStyle={{ padding: 10 }}
      onClick={onClick}
    >
      <div style={{ marginBottom: 8, cursor: 'pointer' }}>
        <CharacterCell characterName={stat.characterName} weaponName={stat.weaponName} />
      </div>
      <Row gutter={[4, 8]}>
        <Col span={8}>
          <MobileStatBox
            label="게임 수"
            value={<DualValue main={stat.gameCount} tier={hasTierData ? stat.tierData.gameCount : undefined} />}
          />
        </Col>
        <Col span={8}>
          <MobileStatBox
            label="승리 횟수"
            value={<DualValue
              main={`${stat.victory} (${(stat.victory * 100 / gameCount).toFixed(1)}%)`}
              tier={hasTierData ? `${stat.tierData.victory || 0} (${((stat.tierData.victory || 0) * 100 / tierGameCount).toFixed(1)}%)` : undefined}
            />}
          />
        </Col>
        <Col span={8}>
          <MobileStatBox
            label="TOP 3"
            value={<DualValue
              main={`${stat.top3} (${(stat.top3 * 100 / gameCount).toFixed(1)}%)`}
              tier={hasTierData ? `${stat.tierData.top3 || 0} (${((stat.tierData.top3 || 0) * 100 / tierGameCount).toFixed(1)}%)` : undefined}
            />}
          />
        </Col>
        <Col span={8}>
          <MobileStatBox
            label="평균 순위"
            value={<DualValue
              main={(stat.gameRank / gameCount).toFixed(2)}
              tier={hasTierData ? ((stat.tierData.gameRank || 0) / tierGameCount).toFixed(2) : undefined}
            />}
          />
        </Col>
        <Col span={8}>
          <MobileStatBox
            label="평균 TK"
            value={<DualValue
              main={(stat.teamKill / gameCount).toFixed(2)}
              tier={hasTierData ? ((stat.tierData.teamKill || 0) / tierGameCount).toFixed(2) : undefined}
            />}
          />
        </Col>
        <Col span={8}>
          <MobileStatBox
            label="플레이어 킬"
            value={<DualValue
              main={(stat.playerKill / gameCount).toFixed(2)}
              tier={hasTierData ? ((stat.tierData.playerKill || 0) / tierGameCount).toFixed(2) : undefined}
            />}
          />
        </Col>
        <Col span={8}><MobileStatBox label="어시스트" value={(stat.playerAssistant / gameCount).toFixed(2)} /></Col>
        <Col span={8}>
          <MobileStatBox
            label="딜량"
            value={<DualValue
              main={formatNumber(Math.floor(stat.damageToPlayer / gameCount))}
              tier={hasTierData ? formatNumber(Math.floor((stat.tierData.damageToPlayer || 0) / tierGameCount)) : undefined}
            />}
          />
        </Col>
        <Col span={8}><MobileStatBox label="동물 킬" value={(stat.monsterKill / gameCount).toFixed(2)} /></Col>
        <Col span={8}><MobileStatBox label="동물 딜량" value={formatNumber(Math.floor(stat.damageToMonster / gameCount))} /></Col>
        <Col span={8}><MobileStatBox label="받은 피해량" value={formatNumber(Math.floor(stat.damageFromPlayer / gameCount))} /></Col>
        <Col span={8}><MobileStatBox label="팀원 치유" value={formatNumber(Math.floor(stat.teamRecover / gameCount))} /></Col>
        <Col span={8}><MobileStatBox label="cc 시간" value={(stat.ccTimeToPlayer / gameCount).toFixed(2)} /></Col>
        <Col span={8}><MobileStatBox label="시야 점수" value={formatNumber(Math.floor(stat.viewContribution / gameCount))} /></Col>
      </Row>
    </Card>
  );
}

export default function Stat({ playerName }) {
  const [range, setRange] = useState([
    dayjs().subtract(1, 'days').hour(6).minute(0),
    dayjs().hour(6).minute(0)
  ]);
  const [data, setData] = useState([]);
  const [tiers, setTiers] = useState(
    TIER_KEYS.reduce((acc, t) => ({ ...acc, [t]: false }), {})
  );
  const [selectedKey, setSelectedKey] = useState(null);
  const [loading, setLoading] = useState(false);
  const isMobile = useIsMobile();

  const handleDateChange = (dates) => {
    if (dates) {
      setRange(dates);
    }
  };

  const handleCheckboxChange = (tier) => {
    setTiers(prevTiers => ({
      ...prevTiers,
      [tier]: !prevTiers[tier]
    }));
  };

  const tableData = useMemo(() => {
    return data.map(stat => {
      const tierData = sumTierStats(stat.tierStats, (t) => tiers[t]) || {};
      return { ...stat, tierData };
    });
  }, [data, tiers]);

  const lastSelectedStat = useMemo(() => {
    if (!selectedKey) {
      return null;
    }
    return tableData.find(
      (row) => `${row.characterName}-${row.weaponName}` === selectedKey
    ) || null;
  }, [tableData, selectedKey]);

  const chartData = useMemo(() => {
    if (!lastSelectedStat) {
      return null;
    }
    const stat = lastSelectedStat;
    const showData = sumTierStats(stat.tierStats, (t) => tiers[t]);
    if (!showData || !showData.gameCount) {
      return null;
    }

    const items = [
      {
        subject: "평균 순위",
        A: 9 - (stat.gameRank / stat.gameCount),
        B: 9 - (showData.gameRank / showData.gameCount)
      },
      {
        subject: "Top 1",
        A: stat.victory / stat.gameCount,
        B: showData.victory / showData.gameCount
      },
      {
        subject: "딜량",
        A: stat.damageToPlayer / stat.gameCount,
        B: showData.damageToPlayer / showData.gameCount
      },
      {
        subject: "Top 3",
        A: stat.top3 / stat.gameCount,
        B: showData.top3 / showData.gameCount
      }
    ];

    return items.map(item => ({
      ...item,
      fullMark: 100,
      A: item.B === 0 ? 0 : item.A * 50 / item.B,
      B: item.B === 0 ? 0 : 50
    }));
  }, [lastSelectedStat, tiers]);

  const handleChangeCharacter = (stat) => {
    if (!stat) {
      return;
    }
    setSelectedKey(`${stat.characterName}-${stat.weaponName}`);
  };

  useEffect(() => {
    setLoading(true);
    axios.get("/api/external/bser/esther-individual-stat", {
      params: {
        playerName: playerName,
        startDateTime: range[0].format(localDateTimeFormat),
        endDateTime: range[1].format(localDateTimeFormat)
      }
    })
      .then(r => r.data)
      .then(data => setData(data))
      .finally(() => setLoading(false));
  }, [playerName, range]);

  useEffect(() => {
    setSelectedKey(null);
  }, [playerName]);

  const totalGameCount = data.reduce((sum, stat) => sum + (stat.gameCount || 0), 0);

  const tierFilterContent = (
    <Space direction="vertical" size="small" style={{ maxWidth: 320 }}>
      <Space wrap>
        {TIER_KEYS.map(tier => (
          <Checkbox
            key={tier}
            checked={tiers[tier]}
            onChange={() => handleCheckboxChange(tier)}
          >
            {tier}
          </Checkbox>
        ))}
      </Space>
    </Space>
  );

  const selectedTierCount = Object.values(tiers).filter(Boolean).length;

  const columns = [
    {
      title: '실험체',
      fixed: 'left',
      render: (_, stat) => (
        <CharacterCell
          characterName={stat.characterName}
          weaponName={stat.weaponName}
        />
      ),
      sorter: (a, b) => (a.characterName || '').localeCompare(b.characterName || '')
    },
    {
      title: '게임 수',
      fixed: 'left',
      align: 'center',
      sorter: (a, b) => a.gameCount - b.gameCount,
      render: (stat) => (
        <>
          <Typography.Text style={{ display: "block" }}>
            {stat.gameCount}
          </Typography.Text>
          <Typography.Text style={{ display: "block", color: "blue" }}>
            {stat.tierData.gameCount || 0}
          </Typography.Text>
        </>
      )
    },
    {
      title: '승리 횟수',
      align: 'center',
      sorter: (a, b) => (a.victory / a.gameCount) - (b.victory / b.gameCount),
      render: (stat) => (
        <>
          <Typography.Text style={{ display: "block" }}>
            {stat.victory} ({(stat.victory * 100 / stat.gameCount).toFixed(2)}%)
          </Typography.Text>
          <Typography.Text style={{ display: "block", color: "blue" }}>
            {stat.tierData.victory || 0} ({((stat.tierData.victory || 0) * 100 / (stat.tierData.gameCount || 1)).toFixed(2)}%)
          </Typography.Text>
        </>
      )
    },
    {
      title: 'TOP 3',
      align: 'center',
      sorter: (a, b) => (a.top3 / a.gameCount) - (b.top3 / b.gameCount),
      render: (stat) => (
        <>
          <Typography.Text style={{ display: "block" }}>
            {stat.top3} ({(stat.top3 * 100 / stat.gameCount).toFixed(2)}%)
          </Typography.Text>
          <Typography.Text style={{ display: "block", color: "blue" }}>
            {stat.tierData.top3 || 0} ({((stat.tierData.top3 || 0) * 100 / (stat.tierData.gameCount || 1)).toFixed(2)}%)
          </Typography.Text>
        </>
      )
    },
    {
      title: '평균 순위',
      align: 'center',
      sorter: (a, b) => (a.gameRank / a.gameCount) - (b.gameRank / b.gameCount),
      render: (stat) => (
        <>
          <Typography.Text style={{ display: "block" }}>
            {(stat.gameRank / stat.gameCount).toFixed(2)}
          </Typography.Text>
          <Typography.Text style={{ display: "block", color: "blue" }}>
            {((stat.tierData.gameRank || 0) / (stat.tierData.gameCount || 1)).toFixed(2)}
          </Typography.Text>
        </>
      )
    },
    {
      title: '평균 TK',
      align: 'center',
      sorter: (a, b) => (a.teamKill / a.gameCount) - (b.teamKill / b.gameCount),
      render: (stat) => (
        <>
          <Typography.Text style={{ display: "block" }}>
            {(stat.teamKill / stat.gameCount).toFixed(2)}
          </Typography.Text>
          <Typography.Text style={{ display: "block", color: "blue" }}>
            {((stat.tierData.teamKill || 0) / (stat.tierData.gameCount || 1)).toFixed(2)}
          </Typography.Text>
        </>
      )
    },
    {
      title: '플레이어 킬',
      align: 'center',
      sorter: (a, b) => (a.playerKill / a.gameCount) - (b.playerKill / b.gameCount),
      render: (stat) => (
        <>
          <Typography.Text style={{ display: "block" }}>
            {(stat.playerKill / stat.gameCount).toFixed(2)}
          </Typography.Text>
          <Typography.Text style={{ display: "block", color: "blue" }}>
            {((stat.tierData.playerKill || 0) / (stat.tierData.gameCount || 1)).toFixed(2)}
          </Typography.Text>
        </>
      )
    },
    {
      title: '어시스트',
      align: 'center',
      sorter: (a, b) => (a.playerAssistant / a.gameCount) - (b.playerAssistant / b.gameCount),
      render: (stat) => (
        <Typography.Text>
          {(stat.playerAssistant / stat.gameCount).toFixed(2)}
        </Typography.Text>
      )
    },
    {
      title: '딜량',
      align: 'center',
      sorter: (a, b) => (a.damageToPlayer / a.gameCount) - (b.damageToPlayer / b.gameCount),
      render: (stat) => (
        <>
          <Typography.Text style={{ display: "block" }}>
            {formatNumber(Math.floor(stat.damageToPlayer / stat.gameCount))}
          </Typography.Text>
          <Typography.Text style={{ display: "block", color: "blue" }}>
            {formatNumber(Math.floor((stat.tierData.damageToPlayer || 0) / (stat.tierData.gameCount || 1)))}
          </Typography.Text>
        </>
      )
    },
    {
      title: '동물 킬',
      align: 'center',
      sorter: (a, b) => (a.monsterKill / a.gameCount) - (b.monsterKill / b.gameCount),
      render: (stat) => (
        <Typography.Text>
          {(stat.monsterKill / stat.gameCount).toFixed(2)}
        </Typography.Text>
      )
    },
    {
      title: '동물 딜량',
      align: 'center',
      sorter: (a, b) => (a.damageToMonster / a.gameCount) - (b.damageToMonster / b.gameCount),
      render: (stat) => (
        <Typography.Text>
          {formatNumber(Math.floor(stat.damageToMonster / stat.gameCount))}
        </Typography.Text>
      )
    },
    {
      title: '받은 피해량',
      align: 'center',
      sorter: (a, b) => (a.damageFromPlayer / a.gameCount) - (b.damageFromPlayer / b.gameCount),
      render: (stat) => (
        <Typography.Text>
          {formatNumber(Math.floor(stat.damageFromPlayer / stat.gameCount))}
        </Typography.Text>
      )
    },
    {
      title: '팀원 치유',
      align: 'center',
      sorter: (a, b) => (a.teamRecover / a.gameCount) - (b.teamRecover / b.gameCount),
      render: (stat) => (
        <Typography.Text>
          {formatNumber(Math.floor(stat.teamRecover / stat.gameCount))}
        </Typography.Text>
      )
    },
    {
      title: 'cc 시간',
      align: 'center',
      sorter: (a, b) => (a.ccTimeToPlayer / a.gameCount) - (b.ccTimeToPlayer / b.gameCount),
      render: (stat) => (
        <Typography.Text>
          {(stat.ccTimeToPlayer / stat.gameCount).toFixed(2)}
        </Typography.Text>
      )
    },
    {
      title: '시야 점수',
      align: 'center',
      sorter: (a, b) => (a.viewContribution / a.gameCount) - (b.viewContribution / b.gameCount),
      render: (stat) => (
        <Typography.Text>
          {formatNumber(Math.floor(stat.viewContribution / stat.gameCount))}
        </Typography.Text>
      )
    }
  ];

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        flexWrap: 'wrap',
        gap: '8px'
      }}>
        <Space direction="horizontal" align="center" wrap>
          <RangePicker
            value={range}
            onChange={handleDateChange}
            format="YYYY-MM-DD HH:mm"
            showTime={{ format: 'HH:mm' }}
            placeholder={['시작 시각', '끝 시각']}
            allowClear={false}
          />
          <Popover
            content={tierFilterContent}
            title={<Typography.Text strong>티어 필터</Typography.Text>}
            trigger="click"
            placement="bottom"
          >
            <Button>
              티어 필터{selectedTierCount > 0 ? ` (${selectedTierCount})` : ''}
            </Button>
          </Popover>
        </Space>
        <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
          총 게임 수: {formatNumber(totalGameCount)}
        </div>
      </div>

      <Typography.Title level={5} style={{ margin: 0 }}>
        실험체 비교 레이더
      </Typography.Title>
      {lastSelectedStat && chartData ? (
        <ResponsiveContainer width="100%" height={400}>
          <RadarChart cx="50%" cy="50%" outerRadius="80%" data={chartData}>
            <PolarGrid />
            <PolarAngleAxis dataKey="subject" />
            <PolarRadiusAxis angle={30} domain={[0, 100]} />
            <Radar name="ScoreA" dataKey="A" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
            <Radar name="ScoreB" dataKey="B" stroke="#84d888" fill="#84d888" fillOpacity={0.59} />
          </RadarChart>
        </ResponsiveContainer>
      ) : lastSelectedStat ? (
        <Empty description={selectedTierCount === 0
          ? "티어 필터를 선택하면 해당 티어 평균과의 비교 레이더가 표시됩니다."
          : "선택한 실험체에 비교 가능한 티어 데이터가 없습니다."} />
      ) : (
        <Empty description="아래 표의 실험체를 클릭하면 비교 레이더가 표시됩니다." />
      )}

      <Divider style={{ margin: '8px 0' }} />

      <Typography.Title level={5} style={{ margin: 0 }}>
        실험체별 데이터
      </Typography.Title>
      {isMobile ? (
        <div>
          {tableData.map((stat) => {
            const key = `${stat.characterName}-${stat.weaponName}`;
            return (
              <EstherIndividualMobileCard
                key={key}
                stat={stat}
                isSelected={selectedKey === key}
                onClick={() => handleChangeCharacter(stat)}
              />
            );
          })}
        </div>
      ) : (
        <Table
          className='table-wrapper-with-border'
          loading={loading}
          dataSource={tableData}
          columns={columns}
          pagination={false}
          rowKey={(record) => `${record.characterName}-${record.weaponName}`}
          scroll={{ x: 'max-content' }}
          onRow={(record) => ({
            onClick: () => handleChangeCharacter(record),
            style: { cursor: 'pointer' }
          })}
          rowClassName={(record) =>
            selectedKey === `${record.characterName}-${record.weaponName}`
              ? 'esther-row-selected'
              : ''
          }
        />
      )}
    </Space>
  );
}
